module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BBREVIATIONS")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ACC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Abilene Christian College")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ACR")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("American Christian Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ACU")])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Abilene Christian University")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BB")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bible Banner")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CB")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Christian Baptist")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CC")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Christian Chronicle")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CE")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Christian Echo")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CF")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Contending for the Faith")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CG")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("David Lipscomb, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Civil Government: Its Origin, Mission, and Destiny, and the Christian’s Relation to It")]), _vm._v(" (Nashville: Gospel Advocate Publishing, 1889), "), _c('a', {
    attrs: {
      "href": "https://digitalcommons.acu.edu/crs_books/63/",
      "target": "_blank"
    }
  }, [_vm._v("https://digitalcommons.acu.edu/crs_books/63/")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CL")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Christian Leader")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CM")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Christian Messenger")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("COCTFC")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Churches of Christ in the Twenty-First Century Oral History Project")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "https://digitalcommons.acu.edu/coc_21stc_oralhistory/",
      "target": "_blank"
    }
  }, [_vm._v("https://digitalcommons.acu.edu/coc_21stc_oralhistory/")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ESCM")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Encyclopedia of the Stone-Campbell Movement")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("FCC")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("First Century Christian")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("FF")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Firm Foundation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("GA")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Gospel Advocate")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("GG")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Gospel Guardian")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("MH")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Millennial Harbinger")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("PTP")])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Polishing the Pulpit")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("RQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Restoration Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sewell Papers")])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sewell Papers, Center for Restoration Studies, Abilene Christian University")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Spiritual Sword")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("20th CC")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("20th Century Christian")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WVBS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("World Video Bible School")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("WW")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Word and Work")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8be1212","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Abbreviations.vue
// module id = 72
// module chunks = 0